import React, { useEffect, useState } from "react";
import styles from "@/static/css/index.module.css";
import { getDays, getTimeFormat } from "@/utils/common";
import { Button, Card, Col, DatePicker, Row, Space } from "antd";
import { statistics } from "@/api";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const TimeData: Record<string, any> = {
  orderNum: "订单数",
  orderPayAmount: "订单金额",
  rewardAmount: "分润金额",
  deviceNum: "设备台数",
  chargingRelationAmount: "服务收益",
  applyWithdrawAmount: "申请提现金额",
  approveWithdrawAmount: "审批提现金额",
  cmsChargeAmount: "后台充值金额",
  cmsDiscountAmount: "后台扣减金额",
  teamTransferAmount: "团队转赠金额",
  teamTransferServiceAmount: "转赠手续费",
  transferAmount: "管理员转赠金额",
  subsidyAmount: "流水收益",
  merchantSameLevelAmount: "经销商流水收益",
  foundationAmount: "公益基金池",
  channelSalesAmount: "渠道销售收益",
  channelFlowAmount: "渠道流水收益",
  applyCashAmount: '用户申请提现金额'
};

const TimeDataList = [
  // "deviceNum",
  "orderNum",
  "orderPayAmount",
  "rewardAmount",
  // "applyWithdrawAmount",
  // "approveWithdrawAmount",
  // "cmsChargeAmount",
  // "cmsDiscountAmount",
  // "teamTransferAmount",
  // "teamTransferServiceAmount",
  // "transferAmount",
  "subsidyAmount",
  "chargingRelationAmount",
  "merchantSameLevelAmount",
  // "foundationAmount",
  // "channelSalesAmount",
  "channelFlowAmount",
  'applyCashAmount'
];

const Home = () => {
  const [pickerValue, setPickerValue] = useState<any>([
    dayjs().startOf("day"),
    dayjs().endOf("day"),
  ]);
  const [showData, setShowData] = useState(false);
  const [homePageData, setHomePageData] = useState<any>({});
  const [weekData, setWeekData] = useState<any>({});
  const [monthData, setMonthData] = useState<any>({});
  const [isCustomDate, setIsCustomDate] = useState(false);
  const [customLoading, setCustomLoading] = useState(false);
  const [weekLoading, setWeekLoading] = useState(false);
  const [monthLoading, setMonthLoading] = useState(false);

  useEffect(() => {
    if (showData) return;
    // 初始化时检查是否是当天
    const today = dayjs().format("YYYY-MM-DD");
    const selectedStart = dayjs(pickerValue[0]).format("YYYY-MM-DD");
    const selectedEnd = dayjs(pickerValue[1]).format("YYYY-MM-DD");
    const isToday = selectedStart === today && selectedEnd === today;
    setIsCustomDate(!isToday);

    // 分别获取三类数据
    getCustomData(pickerValue, isToday);
    // getWeekData();
    // getMonthData();
  }, []); // 只在组件挂载时执行一次

  // 获取自定义时间数据
  const getCustomData = async (customPickerValue?: any, isToday?: boolean) => {
    setCustomLoading(true);
    try {
      const currentPickerValue = customPickerValue || pickerValue;

      const { data: statisticsData }: any = await statistics({
        startTime: dayjs(currentPickerValue[0]).format("YYYY-MM-DD 00:00:00"),
        endTime: dayjs(currentPickerValue[1]).format("YYYY-MM-DD 23:59:59"),
        type: isToday ? 0 : 3,
      });

      setHomePageData({
        ...statisticsData,
        merchantSameLevelAmount: (
          Number(statisticsData.merchantChargingAmount) +
          Number(statisticsData.sameLevelMerchantChargingAmount)+
          Number(statisticsData.weightedFlowAmount
          )
        ).toFixed(2),
        channelSalesAmount: (
          Number(statisticsData.channelSalesAmount || 0) 
        ).toFixed(2),
        channelFlowAmount: (
          Number(statisticsData.channelFlowAmount || 0) 
        ).toFixed(2),
      });
    } catch (error: any) {
      console.log(error, "error");
      if (error.status === 403 || error?.data?.code === 403) {
        setShowData(true);
      }
    } finally {
      setCustomLoading(false);
    }
  };

  // 获取本周数据
  const getWeekData = async () => {
    setWeekLoading(true);
    try {
      const weekStart = dayjs().startOf("week");
      const weekEnd = dayjs().endOf("week");
      const { data: weekData }: any = await statistics({
        startTime: weekStart.format("YYYY-MM-DD 00:00:00"),
        endTime: weekEnd.format("YYYY-MM-DD 23:59:59"),
        type: 1,
      });

      setWeekData({
        ...weekData,
        merchantSameLevelAmount: (
          Number(weekData.merchantChargingAmount) +
          Number(weekData.sameLevelMerchantChargingAmount)
        ).toFixed(2),
      });
    } catch (error: any) {
      console.log(error, "error");
    } finally {
      setWeekLoading(false);
    }
  };

  // 获取本月数据
  const getMonthData = async () => {
    setMonthLoading(true);
    try {
      const monthStart = dayjs().startOf("month");
      const monthEnd = dayjs().endOf("month");
      const { data: monthData }: any = await statistics({
        startTime: monthStart.format("YYYY-MM-DD 00:00:00"),
        endTime: monthEnd.format("YYYY-MM-DD 23:59:59"),
        type: 2,
      });

      setMonthData({
        ...monthData,
        merchantSameLevelAmount: (
          Number(monthData.merchantChargingAmount) +
          Number(monthData.sameLevelMerchantChargingAmount)
        ).toFixed(2),
      });
    } catch (error: any) {
      console.log(error, "error");
    } finally {
      setMonthLoading(false);
    }
  };

  const handleDateChange = (values: any) => {
    if (values && values.length === 2) {
      setPickerValue(values);
      // 判断是否是当天
      const today = dayjs().format("YYYY-MM-DD");
      const selectedStart = dayjs(values[0]).format("YYYY-MM-DD");
      const selectedEnd = dayjs(values[1]).format("YYYY-MM-DD");

      // 判断是否选择的是当天
      const isToday = selectedStart === today && selectedEnd === today;
      setIsCustomDate(!isToday);

      // 手动触发数据更新（只更新自定义时间数据）
      getCustomData(values, isToday);
    }
  };

  const getDateRangeText = () => {
    if (!isCustomDate) {
      return "当日数据";
    }
    const startDate = dayjs(pickerValue[0]).format("MM/DD");
    const endDate = dayjs(pickerValue[1]).format("MM/DD");
    if (startDate === endDate) {
      return `${startDate} 数据`;
    }
    return `${startDate} - ${endDate} 自定义时间数据`;
  };

  return showData ? (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 24,
      }}
    >
      欢迎使用友电之星管理后台
    </div>
  ) : (
    <div>
      <div className={styles.home}>
        <div className={styles.home_body}>
          <div className={styles.home_title}>
            <div style={{ marginRight: "24px" }}>{getDateRangeText()}</div>
            <Space size={16}>
              <RangePicker
                value={pickerValue}
                format="YYYY-MM-DD"
                allowClear={false}
                onChange={handleDateChange}
              />

              <Button
                onClick={() =>
                  handleDateChange([
                    dayjs().startOf("day"),
                    dayjs().endOf("day"),
                  ])
                }
                style={{ marginLeft: "0px" }}
              ><div>重置</div></Button>
            </Space>
          </div>
          <Row gutter={[8, 16]}>
            {TimeDataList.map((v, i) => (
              <Col span={4} key={i}>
                <Card bordered={false} loading={customLoading}>
                  <div className={styles.home_body_col}>
                    <span>{TimeData[v]}</span>
                    <span className={styles.col_price}>
                      {homePageData?.[v] || 0}
                    </span>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
          {/* <div className={styles.home_title} style={{ marginTop: 20 }}>
            本周数据 <span></span>
          </div>
          <Row gutter={[8, 16]}>
            {TimeDataList.map((v, i) => (
              <Col span={4} key={i}>
                <Card bordered={false} loading={weekLoading}>
                  <div className={styles.home_body_col}>
                    <span>{TimeData[v]}</span>
                    <span className={styles.col_price}>
                      {weekData?.[v] || 0}
                    </span>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
          <div className={styles.home_title} style={{ marginTop: 20 }}>
            本月数据 <span></span>
          </div>
          <Row gutter={[8, 16]}>
            {TimeDataList.map((v, i) => (
              <Col span={4} key={i}>
                <Card bordered={false} loading={monthLoading}>
                  <div className={styles.home_body_col}>
                    <span>{TimeData[v]}</span>
                    <span className={styles.col_price}>
                      {monthData?.[v] || 0}
                    </span>
                  </div>
                </Card>
              </Col>
            ))}
          </Row> */}
        </div>
      </div>
    </div>
  );
};

export default Home;
